export const creditRequestStatuses = [
  "Pending",
  "Approved",
  "Requires proof",
  "Rejected",
  "Reopened",
  "Auto approved"
]

export const creditRequestStatusTextMap = {
  Pending: "Pending",
  Approved: "Approved",
  "Requires proof": "Requires proof",
  Rejected: "Rejected",
  Reopened: "Reopened",
  "Auto approved": "Auto approved"
}

export const creditRequestStatusTagMap = {
  Pending: "pending",
  Approved: "success",
  "Requires proof": "warning",
  Rejected: "error",
  Reopened: "neutral",
  "Auto approved": "success"
}

export const crProviderStatuses = [
  "Pending",
  "Request sent",
  "Approved",
  "Requires proof",
  "Ineligible",
  "Rejected"
]
